// extracted by mini-css-extract-plugin
export var columnItem = "_bv-3";
export var columnItemDraggable = "_bv-4";
export var dragHandle = "_bv-0";
export var dragHandleHovered = "_bv-1";
export var dropdown = "_bv-5";
export var dropdownContent = "_bv-7";
export var dropdownInner = "_bv-6";
export var filterDropdownHeader = "_bv-8";
export var icon = "_bv-2";
export var sectionDivider = "_bv-9";